import styled from "styled-components";
import { Typography } from "@atoms";

export const PeopleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 270px;
`;

export const MobilePeopleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const PeopleItems = styled.div`
  padding: 6px;
  background: #f9f2ec;
  border: 1px solid #e4d7cd;
  border-radius: 8px;
  width: 100%;
  min-width: 270px;
`;

export const PeopleItem = styled(Typography).attrs({ as: "h3" })`
  padding: 10px 18px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background: rgba(240, 229, 222, 0.5);
  }

  &.active {
    background: rgba(240, 229, 222, 1);
  }
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  margin: 16px 0;
  background: #e4d7cd;
`;
